import type { LucideIcon } from 'lucide-react';

export const TIPOS_DE_MARCO = [
  'CASE_CREATED',
  'OFFER_SENT',
  'OFFER_RECEIVED',
  'MESSAGE_SENT',
  'MESSAGE_RECEIVED',
  'DECISION_MADE',
  'SCHEDULED',
  'MEDIATION_SUGGESTED',
  'AGREEMENT_FORMALIZED',
  'CONTRACT_SENT',
  'CONTRACT_SEND_FAILED',
  'CONTRACT_SIGNED',
  'SIGNATURE_STALLED',
  'PAYMENT_UPDATE',
  'AUTOMATION_RESUMED_DIRECTED',
  'CASE_CLOSED',
  'CASE_REOPENED',
  'SCHEDULED_MESSAGES_CANCELLED',
  'HUMAN_SUPPORT_CLOSED',
  'MESSAGE_DELIVERY_FAILED',
  'ENVIO_VISUALIZADO',
  'CASO_ENCERRADO_ACORDO_IA',
  'CASO_ENCERRADO_ACORDO_MANUAL',
  'CASO_ENCERRADO_DESISTENCIA',
  'CASO_ENCERRADO_CANCELAMENTO',
  'CASO_ENCERRADO_TIMEOUT',
  'CASO_ENCERRADO_FALHA_TECNICA',
  'PRIMEIRO_CONTATO_ENVIADO',
  'PRIMEIRO_CONTATO_FALHOU',
  'NOVA_TENTATIVA_CONTATO',
  'CONTATO_CANAL_ALTERADO',
  'CONTRAPARTE_RESPONDEU',
  'NEGOCIACAO_PAUSADA',
  'NEGOCIACAO_RETOMADA',
  'ATENDIMENTO_HUMANO_ACIONADO',
  'MENSAGEM_REENVIADA',
  'MARCO_NAO_RECONHECIDO',
] as const;

export type TipoMarco = (typeof TIPOS_DE_MARCO)[number];

export type TomMarco = 'brand' | 'erro';

export interface AparenciaMarco {
  icone: LucideIcon;
  tom: TomMarco;
}

export interface DuracaoInput {
  dataCriacao: string | null | undefined;
  dataEncerramento: string | null | undefined;
  agora?: Date;
}

export interface FetchMarcosOptions {
  cursor?: string;
  signal?: AbortSignal;
}

export const TIPOS_DE_ATOR = ['IA', 'USUARIO', 'CONTRAPARTE', 'SISTEMA', 'DESCONHECIDO'] as const;

export type TipoAtorMarco = (typeof TIPOS_DE_ATOR)[number];

export interface AtorMarco {
  tipo: TipoAtorMarco;
  nome: string | null;
}

export interface LinkMarco {
  url: string;
  rotulo: string;
}

export interface MarcoNegociacao {
  id: string;
  tipo: string;
  titulo: string;
  descricao: string;
  ator: AtorMarco;
  dataHora: string;
  link: LinkMarco | null;
}

export interface GrupoMarcosDoDia {
  chave: string;
  rotulo: string;
  items: MarcoNegociacao[];
}

export interface PaginaMarcos {
  items: MarcoNegociacao[];
  nextCursor: string | null;
  hasMore: boolean;
}

export type EtiquetaAutoria = 'Automação' | 'Atividade humana' | null;

export type MarcosStatus = 'idle' | 'loading' | 'succeeded' | 'failed';

export interface MarcosState {
  casoId: string | null;
  requestId: string | null;
  items: MarcoNegociacao[];
  nextCursor: string | null;
  hasMore: boolean;
  status: MarcosStatus;
  error: string | null;
  tentativas: number;
}

export type MarcosViewState =
  | { estado: 'carregando' }
  | { estado: 'erro'; mensagem: string; sugerirSuporte: boolean }
  | { estado: 'vazio' }
  | {
      estado: 'lista';
      items: MarcoNegociacao[];
      hasMore: boolean;
      carregandoMais: boolean;
    };
